var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1635233667473,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5787,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 0a512 512 0 0 0 0 1024A512 512 0 0 0 512 0z m-3.291429 870.253714c-41.691429 0-75.556571-33.133714-75.556571-74.020571 0-40.813714 33.792-74.020571 75.556571-74.020572 41.691429 0 75.556571 33.206857 75.556572 74.020572 0 40.886857-33.792 74.020571-75.556572 74.020571z m202.898286-418.889143c-14.848 23.332571-46.226286 55.003429-94.500571 95.085715-24.941714 20.772571-40.521143 37.449143-46.518857 50.176-5.997714 12.580571-8.777143 35.181714-8.192 67.803428H454.802286l-0.512-28.233143c0-34.889143 5.851429-63.488 17.334857-85.942857 11.556571-22.454857 34.596571-47.762286 69.12-75.776 34.450286-28.16 55.149714-46.518857 61.878857-55.222857 10.386286-13.750857 15.652571-28.964571 15.652571-45.421714 0-22.966857-9.289143-42.642286-27.648-59.099429-18.358857-16.384-43.300571-24.576-74.532571-24.576-30.134857 0-55.296 8.557714-75.556571 25.6-20.260571 17.115429-37.668571 54.784-41.764572 78.043429-3.876571 22.016-109.933714 31.305143-108.617143-13.238857 1.243429-44.617143 24.429714-93.037714 64.219429-128.073143 39.789714-35.108571 92.086857-52.662857 156.672-52.662857 68.022857 0 122.075429 17.773714 162.377143 53.394285 40.228571 35.474286 60.196571 76.8 60.196571 123.977143 0.146286 26.185143-7.314286 50.907429-21.942857 74.166857z",
    "p-id": 5788
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.5bbd131b.svg";
export { ForwardRef as ReactComponent };